<template>
    <van-popup class="popWrap" v-model="show" @close="show = false" position="bottom" closeable round :lazy-render="false" :get-container="getContainer" :style="{height: '95%'}">
        <div class="iframe-wrap">
            <div class="title">计费规则</div>
            <iframe :src="rulesUrl" frameborder="0" id="iframe"></iframe>
        </div>
    </van-popup>
</template>

<script>

export default {
    data () {
        return {
            rulesUrl:process.env.VUE_APP_RULES,
            show: false,
        }
    },
    components: {},
    created () {
        console.log(this.rulesUrl)
    },
    watch: {},
    computed: {},
    mounted () {
        
    },
    methods: {
        getContainer() {
            return document.querySelector('.main');
        },
        open(){
            this.show = true
        },
    }
}
</script>

<style lang='less' scoped>
.popWrap{
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .iframe-wrap{
        flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .title{
            height: 60px;
            width: 100%;
            font-size: 20px;
            color: #000;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        iframe{
            flex: 1;
            width: 100%;
        }
    }
}
</style>
